// extracted by mini-css-extract-plugin
export default {"content":"GuestOrderViewPage_content__bkrsL"};